import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../Store/store';

const AdminProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isLoggedIn = useAppSelector(state => state.user.isLoggedIn);
  const role = useAppSelector(state => state.user.role);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
